module.exports = __webpack_public_path__ + "static/media/25.d5b25e83.mp3";